module.exports = __webpack_public_path__ + "img/icm-semina-popup.b525a8bf.png";